import { render, staticRenderFns } from "./withholdTax.vue?vue&type=template&id=0121d68f&scoped=true&"
import script from "./withholdTax.vue?vue&type=script&lang=js&"
export * from "./withholdTax.vue?vue&type=script&lang=js&"
import style0 from "./withholdTax.vue?vue&type=style&index=0&id=0121d68f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0121d68f",
  null
  
)

export default component.exports